import axios from "axios";

const loadSentEmails = (callback) => {
    const config = {
        url: '/api/sent-emails',
        method: 'GET'
    }

    axios.request(config).then(response => callback(response.data));
}

const getSentEmail = (id, callback) => {
    const config = {
        url: `/api/sent-emails/${id}`,
        method: 'GET'
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteSentEmail = (id, callback) => {
    const config = {
        url: `/api/sent-emails/${id}`,
        method: 'DELETE'
    }

    axios.request(config)
        .then(() => callback({ success: true }))
        .catch(error => callback({
            success: false,
            data: error.response ? error.response.data : error.message
        }));
}

const deleteAllSentEmails = (callback) => {
    const config = {
        url: '/api/sent-emails',
        method: 'DELETE'
    }

    axios.request(config)
        .then(() => callback({ success: true }))
        .catch(error => callback({
            success: false,
            data: error.response ? error.response.data : error.message
        }));
}

const sentEmailsActions = {
    loadSentEmails,
    getSentEmail,
    deleteSentEmail,
    deleteAllSentEmails
}

export default sentEmailsActions;